import { datadogRum } from "@datadog/browser-rum";

import type { ErrorOptions, SeverityLevel } from "../types";

/**
 * Helper function to send errors to DataDog RUM with consistent error handling
 */
export function sendErrorToDatadog(
  error: unknown,
  context?: Record<string, unknown>
): void {
  if (typeof window === "undefined") return;

  try {
    if (error instanceof Error) {
      datadogRum.addError(error, context);
    } else {
      datadogRum.addError(new Error(String(error)), context);
    }
  } catch (e) {
    // Silently fail if DataDog is not initialized
    console.warn("DataDog RUM not initialized or failed to send error", e);
  }
}

/**
 * Helper function to create DataDog context from error options
 */
export function createDatadogContext(
  options?: ErrorOptions
): Record<string, unknown> | undefined {
  if (!options) return undefined;

  const context: Record<string, unknown> = {
    ...options.tags,
    ...options.extra
  };

  if (options.level) {
    context.level = options.level;
  }

  if (options.user && Object.keys(options.user).length > 0) {
    context.user = options.user;
  }

  if (options.fingerprint?.length) {
    context.fingerprint = options.fingerprint;
  }

  return Object.keys(context).length > 0 ? context : undefined;
}
